import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.3502 6.2261'
  const rightTransformOrigin = '39.6104 6.2261'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 7.93605L19.25 4.4861L17.3 1.99611C17.3 1.99611 11.01 0.976103 6.28 1.9861C1.54 2.9961 0 7.93605 0 7.93605Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M0.660156 6.22608C0.660156 6.22608 4.14016 3.06602 7.33016 2.79602C10.5202 2.52602 18.0402 2.92603 18.0402 2.92603L16.0902 0.436039C16.0902 0.436039 11.6502 0.176039 6.92016 1.18604C2.20016 2.19604 0.660156 6.22608 0.660156 6.22608Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M48.9702 7.93605L29.7202 4.4861L31.6702 1.99611C31.6702 1.99611 37.9602 0.976103 42.6902 1.9861C47.4202 2.9961 48.9702 7.93605 48.9702 7.93605Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M48.3004 6.22608C48.3004 6.22608 44.8204 3.06602 41.6304 2.79602C38.4404 2.52602 30.9204 2.92603 30.9204 2.92603L32.8704 0.436039C32.8704 0.436039 37.3104 0.176039 42.0404 1.18604C46.7704 2.19604 48.3004 6.22608 48.3004 6.22608Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="9.6251"
            y1="9.0422"
            x2="9.6251"
            y2="3.22968"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="39.3453"
            y1="9.0422"
            x2="39.3453"
            y2="3.22968"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
